import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingService } from './../../services/setting.service';
import { UserService } from './../../services/user.service';
import { CommonService } from './../../services/common.service';
import { EncrDecrService } from '../../services/encr-decr.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  user_id: any = '';
  APIKEY: any = '';
  formmodel: any = {};
  editUserForm: FormGroup;
  user_comapny_id: any = 0;
  edit_userid: any = 0;
  company_id: any = 0;
  role_list: any = '';
  customer_list_event: boolean = false;
  roleDisabled: boolean = true;
  submitted: any = false;

  constructor(
    private _setting: SettingService,
    private _router: Router,
    private toastr: ToastrService,
    private EncrDecr: EncrDecrService,
    private _User: UserService, 
    private formBuilder: FormBuilder, 
    private _Common: CommonService
    ) { }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.formmodel = {
      APIKEY: this.APIKEY,
      user_id: this.user_id
    };

    this.setFormValue();
    this.getEditProfile();

  }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.editUserForm.invalid) {
      return;
    }

    const formData = new FormData();
    formData.append('first_name', this.editUserForm.get('first_name').value);
    formData.append('last_name', this.editUserForm.get('last_name').value);
    formData.append('email', this.editUserForm.get('email').value);
    formData.append('password', this.EncrDecr.set(localStorage.getItem('key'), this.editUserForm.get('password').value));
    // formData.append('password', this.editUserForm.get('password').value);
    formData.append('phone', this.editUserForm.get('phone').value);
    formData.append('alter_phone', this.editUserForm.get('alter_phone').value);
    formData.append('note', this.editUserForm.get('note').value);
    formData.append('id', this.editUserForm.get('id').value);
    formData.append('role', this.editUserForm.get('role').value);
    formData.append('status', this.editUserForm.get('status').value);
    formData.append('user_id', this.user_id);
    formData.append('company_id', this.company_id);
    formData.append('APIKEY', this.APIKEY);


    this._User.updateUSer(formData).subscribe(
      res => {
        //  console.log(res.message);
        if (res.status == true) {  //return false;
          this.toastr.success('Profile updated successfully', 'Success');
          //this. ngOnInit();
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/super-admin/edit-profile');
          });
        }
        else {
          this.toastr.error(res.message, 'Error');
        }
      }
    );
  }





  getEditProfile() {

    const data = {
      APIKEY: this.APIKEY,
      edit_userid: this.user_id,
      company_id: this.company_id,
    }


    this._User.getUserInfo(data)
      .subscribe(res => {
        // console.log(res.data);
        this.user_comapny_id = res.data.company_id;
        const roleData = {
          APIKEY: this.APIKEY,
          edit_userid: this.edit_userid,
          company_id: this.user_comapny_id,
        }

        this.getRoleList(roleData);


        this.editUserForm.get('alter_phone').setValue(res.data.alter_phone);
        this.editUserForm.get('email').setValue(res.data.email);
        this.editUserForm.get('first_name').setValue(res.data.first_name);
        this.editUserForm.get('id').setValue(res.data.id);
        this.editUserForm.get('last_name').setValue(res.data.last_name);
        this.editUserForm.get('note').setValue(res.data.note);
        this.editUserForm.get('password').setValue(this.EncrDecr.get(localStorage.getItem('key'), res.data.password));
        // this.editUserForm.get('password').setValue(res.data.password);
        this.editUserForm.get('phone').setValue(res.data.phone);
        this.editUserForm.get('role').setValue(res.data.role);
        this.editUserForm.get('status').setValue(res.data.status);

        if (res.data.urole_type == 'CompanyAdmin') {


        }

        // console.log(this.roleMode);


        var role_name = res.data.role;
        var splitrole_name = role_name.split("-", 3);
        if (splitrole_name[1] == 'Professional User') { this.customer_list_event = true; }

        //if(res.data.customer_per=='all'){this.check_per_mode= true;}

      });
  }

  setFormValue() {
    this.editUserForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: [''],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      phone: [''],
      alter_phone: [''],
      role: [{ value: '', disabled: false }, Validators.required],
      note: [''],
      company_id: [''],
      status: ['active'],
      id: ['0'],

    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.editUserForm.controls; }

  getRoleList(data) {
    this._Common.getRoleList(data)
      .subscribe(
        res => {
          //   console.log(res);
          this.role_list = res.data;
        },
      );
  }


}
